export default class SearchBox {
  constructor() {
    this.init()
  }

  init() {
    let that = this

    $('#SearchBox form').on('submit', function () {
      $('#SearchBox .icon-search').hide()
      $('#SearchBox .icon-loading').show()
    });

    $('.nav-mobile-search').on('submit', function() {
      $('.nav-mobile-search .icon-search').hide()
      $('.nav-mobile-search .icon-loading').show()
    });

    $('#SearchBox .search-btn').on('click', function () {
      // If search box is hidden
      if ($('#SearchBox .search-container').is(':hidden')) {
        // Show the search box
        that.open()
      } else {
        // Close the search box
        that.close()
      }
    });

    window.addEventListener('resize', function () {
      that.close()
    });

    window.addEventListener('click', function (e) {
      // Templates without the site header (Landing Page, Content Only) have no #SearchBox,
      // and an unguarded .contains() here throws on every click on the page.
      const searchBox = document.querySelector('#SearchBox')

      if (searchBox && !searchBox.contains(e.target)) {
        that.close()
      }
    });
  }

  open () {
    if ($('#SearchBox .search-container').is(':hidden')) {
      $('#SearchBox .search-btn').addClass('text-mango-tango').removeClass('text-blue-prussian')
      $('#SearchBox .search-container').show()
    }
  }

  close () {
    if ($('#SearchBox .search-container').is(':visible')) {
      $('#SearchBox .search-btn').removeClass('text-mango-tango').addClass('text-blue-prussian')
      $('#SearchBox .search-container').hide()
    }
  }
}
